import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@mui/material"
import {optimizeRouteClients, optimizeRouteClientRows} from "api/customer/documents.api"
import JSDB from "fromKotlin/nk"
import {Map} from "tabler-icons-react"
import React from "react";
import {hasTempOrderDriver, orderKey} from "types/OrderData";

export const ReorderDialogOrders = ({ reorderDialog, setReorderDialog,setData,setRefreshRowIds,updatedDriverRowIds ,updatedRowIds}) => {
    const [start, setStart] = React.useState<string>(reorderDialog?.start ||'')
    const [end, setEnd] = React.useState<string>( reorderDialog?.end ||'')
    const [startPosition, setStartPosition] = React.useState<number>( 1)
    const [jumps, setJumps] = React.useState<number>( 1)
    React.useEffect(() => {
        console.log(reorderDialog)
        setStart(reorderDialog?.start ||'')
        setEnd(reorderDialog?.end ||'')
    }, [reorderDialog])
  return (
    <>
      <Dialog
        open={reorderDialog}
        onClose={() => setReorderDialog(undefined)}
        aria-labelledby="reorder-dialog-title"
        aria-describedby="reorder-dialog-description"
        sx={{
          ".MuiDialog-paper": {
            overflow: "visible",
          }
        }
        }
      >
          <DialogTitle id="reorder-dialog-title">{`שינוי סדר לקוחות(${reorderDialog?.data?.length}) עבור ${reorderDialog?.ag?.user_name}`}</DialogTitle>
          <DialogContent>
              <DialogContentText id="reorder-dialog-description">
                  בחר לקוח מתוך הרשימה או הכנס <b>נקודות ציון</b>
              </DialogContentText>
              <div style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  marginTop: "10px",
                  gap: "10px",
              }}>
                  <Autocomplete
                      style={{ width: 200 }}
                      disablePortal
                      id="customers-search-plan-route-start"
                      options={[]}
                      freeSolo
                      // getOptionLabel={(option: any) => option?.customer}
                      onChange={(e, value) => {
                          console.log(value)

                      }}
                      onInputChange={(e, value) => {
                          if (value) {
                              setStart(value)
                          }
                      }}
                      // isOptionEqualToValue={(option: any, value: any) => {
                      //     return option?.id === value?.id;
                      // }}
                      value={start}
                   renderInput={(params) => <TextField {...params} label="נקודת התחלה" />}

                  />
                  <Autocomplete
                      style={{ width: 200 }}
                      disablePortal
                      id="customers-search-plan-route-end"
                      options={[]}
                      freeSolo
                      value={end}
                      // getOptionLabel={(option: any) => option?.customer}
                      // renderOption={(props, option) => {
                      //     return (
                      //         <li {...props}>
                      //             <div style={{
                      //                 display: "flex",
                      //                 flexDirection: "column",
                      //             }}>
                      //                 <span>{option?.customer}</span>
                      //                 <span>{option?.city}</span>
                      //             </div>
                      //         </li>
                      //     )
                      // }}
                      onInputChange={(e, value) => {
                          if (value) {
                              setEnd(value)
                          }
                      }}
                      onChange={(e, value) => {
                          if (value) {
                                setEnd(value)
                          }
                      }}
                      renderInput={(params) => <TextField {...params} label="נקודת סיום" />}

                  />
              </div>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => setReorderDialog(undefined)}>ביטול</Button>
              <Button onClick={async () => {
                  const rows = (reorderDialog as any)?.data;
                  const customersIds = rows.map((row) => Number(row?.id));
                  // static_data forced addresses of the orders replace the client address in the optimization.
                  // Kept *per row* (not per client id): the same client can have more than one row here —
                  // e.g. its regular order plus a one-off order with a forced/כתובת מאולצת address — and
                  // each row needs its own address resolved independently.
                  const forcedAddresses = rows.map((row) => (row?.forced_address && row.forced_address !== '') ? row.forced_address : undefined);
                  const {orderedIndices} = await optimizeRouteClientRows(customersIds, true, start, end, forcedAddresses);
                  // Map back by orderKey (row identity), not client id: with a forced address it's common
                  // for the same client to have two selected rows, which must each get their own position
                  // instead of colliding on a shared id — and orderKey also matches the grid's row node id
                  // scheme, so setRefreshRowIds below actually finds the rows to refresh.
                  const positionByRowKey: Record<string, number> = {};
                  orderedIndices.forEach((rowIndex, position) => {
                      positionByRowKey[orderKey(rows[rowIndex])] = startPosition + position * jumps;
                  });
                  const x = new Set();
                  setData((prev) =>
                      prev.map((d, i) => {
                              const key = orderKey(d);
                              if (key in positionByRowKey) {
                                  updatedDriverRowIds.add(d.id);

                                  x.add(key)
                                  const forced = hasTempOrderDriver(d) || d.force_position_on || d.readonly;
                                  if (forced) {
                                      // Order with a נהג זמני / forced position / closed: the new order is stored on the
                                      // order itself (force_position), so the order save must run for this row too.
                                      updatedRowIds?.add(orderKey(d));
                                      return {
                                          ...d,
                                          daily_position: d.force_position_on ? d.daily_position : d.driver_position,
                                          force_position_on: true,
                                          driver_position: positionByRowKey[key],
                                      };
                                  }
                                  return {
                                      ...d,
                                      driver_position: positionByRowKey[key],
                                  };
                              }
                              return d;
                          }
                      )
                  );
                  setRefreshRowIds(x)




                  setReorderDialog(undefined)
              }} autoFocus>
                  הפעל אופטימיזציה
              </Button>
          </DialogActions>
      </Dialog >
    </>
  )
}


const ReorderDialog = ({ reorderDialog, setReorderDialog, reorderPosition, setReorderPosition }) => {
  return (
      <>
        <Dialog
            open={(reorderDialog as {
              driver: string,
              data: any[],
              api: any,
            })?.driver ? true : false}
            onClose={() => setReorderDialog(false)}
            aria-labelledby="reorder-dialog-title"
            aria-describedby="reorder-dialog-description"
            sx={{
              ".MuiDialog-paper": {
                overflow: "visible",
              }
            }
            }
        >
          <DialogTitle id="reorder-dialog-title">{"שינוי סדר לקוחות"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="reorder-dialog-description">
              בחר לקוח מתוך הרשימה או הכנס <b>נקודות ציון</b>
            </DialogContentText>
            <div style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              marginTop: "10px",
              gap: "10px",
            }}>
              <Autocomplete
                  style={{ width: 200 }}
                  disablePortal
                  id="customers-search-plan-route-start"
                  options={(reorderDialog as {
                    driver: string,
                    data: any[],
                    api: any,
                  })?.data}
                  freeSolo
                  getOptionLabel={(option: any) => option?.customer}
                  onChange={(e, value) => {
                    if (value?.id) {
                      setReorderPosition({
                        ...reorderPosition,
                        start: value.id,
                      });
                    }
                  }}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.id === value?.id;
                  }}
                  defaultValue={() => {
                    return {
                      customer: reorderPosition?.start || "",
                    }
                  }}
                  renderInput={(params) => <TextField {...params}
                                                      label={
                                                        <span style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                          alignItems: "center",
                                                          justifyContent: "space-between",
                                                          width: 170,
                                                        }}>
                    נקודת התחלה {(params?.inputProps?.['aria-controls'] || params?.inputProps?.value?.length > 0) ? undefined : <Map />}
                  </span>
                                                      } onChange={(e) => {
                    setReorderPosition({
                      ...reorderPosition,
                      start: e?.target?.value.replace(/\s/g, ''),
                    });
                  }} />}
              />
              <Autocomplete
                  style={{ width: 200 }}
                  disablePortal
                  id="customers-search-plan-route-end"
                  options={(reorderDialog as {
                    driver: string,
                    data: any[],
                    api: any,
                  })?.data}
                  freeSolo
                  getOptionLabel={(option: any) => option?.customer}
                  renderOption={(props, option) => {
                    return (
                        <li {...props}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                          }}>
                            <span>{option?.customer}</span>
                            <span>{option?.city}</span>
                          </div>
                        </li>
                    )
                  }}
                  defaultValue={() => {
                    return {
                      customer: reorderPosition?.end || "",
                    }
                  }}
                  onChange={(e, value) => {
                    if (value?.id) {
                      setReorderPosition({
                        ...reorderPosition,
                        end: value.id,
                      });
                    }
                  }}
                  renderInput={(params) => <TextField {...params} onChange={(e) => {
                    setReorderPosition({
                      ...reorderPosition,
                      end: e.target.value.replace(/\s/g, ''),
                    });
                  }}
                                                      value={reorderPosition?.end || ""}
                                                      label={
                                                        <span style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                          alignItems: "center",
                                                          justifyContent: "space-between",
                                                          width: 170,
                                                        }}>
                    נקודת סיום {(params?.inputProps?.['aria-controls'] || params?.inputProps?.value?.length > 0) ? undefined : <Map />}
                  </span>
                                                      } />}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setReorderDialog(false)}>ביטול</Button>
            <Button onClick={async () => {
              const tableApi = (reorderDialog as {
                driver: string,
                data: any[],
                api: any,
              })?.api;
              const rows = (reorderDialog as any)?.data;
              const customersIds = rows.map((row) => Number(row?.id)).filter((id) => id);
              const startLocation = reorderPosition.start.includes(",") ? reorderPosition.start : JSDB().getClient(Number(reorderPosition.start))?.first?.location;
              const endLocation = reorderPosition.end.includes(",") ? reorderPosition.end : JSDB().getClient(Number(reorderPosition.end))?.first?.location;
              startLocation && endLocation && localStorage.setItem(`driver_${(reorderDialog as any)?.driver}_position`, JSON.stringify({
                start_position: startLocation,
                end_position: endLocation,
              }));
              const r = await optimizeRouteClients(customersIds, undefined, true, startLocation, endLocation);
              const newRows = r.map((id) => {
                const row = rows.find((row) => Number(row?.id) === id);
                return row;
              }).filter((row) => row);
              const driver = tableApi.rowModel.rowsToDisplay.find((row) => row?.data?.id === reorderDialog?.driver);
              const data = driver?.data?.isDriver ? driver?.childrenAfterGroup : driver?.parent?.data?.isDriver ? driver?.parent?.childrenAfterGroup : undefined;
              tableApi.applyTransaction({
                remove: data,
              });
              tableApi.applyTransaction({
                add: newRows
              });
              setReorderDialog(false)
            }} autoFocus>
              שמור
            </Button>
          </DialogActions>
        </Dialog >
      </>
  )
}

export default ReorderDialog;
